module.exports = __webpack_public_path__ + "img/fantom.8e894541.png";